import image1 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image1.webp";
import image2 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image2.webp";
import image3 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image3.webp";
import image4 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image4.webp";
import image5 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image5.webp";
import image6 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image6.webp";
import image7 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image7.webp";
import image8 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image8.webp";
import image9 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image9.webp";
import image10 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image10.webp";
import image11 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image11.webp";
import image12 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image12.webp";
import image13 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image13.webp";
import image14 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image14.webp";
import image15 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image15.webp";
import image16 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image16.webp";
import image17 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image17.webp";
import image18 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image18.webp";
import image19 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image19.webp";
import image20 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image20.webp";
import image21 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image21.webp";
import image24 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image24.webp";
import image25 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image25.webp";
import image26 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image26.webp";
import image27 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image27.webp";
import image28 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image28.webp";
import image29 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image29.webp";
import image30 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image30.webp";
import image31 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image31.webp";
import image32 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image32.webp";
import image33 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image33.webp";
import image34 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image34.webp";
import image35 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image35.webp";
import image36 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image36.webp";
import image37 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image37.webp";
import image38 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image38.webp";
import image39 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image39.webp";
import image40 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image40.webp";
import image41 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image41.webp";
import image42 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image42.webp";
import image43 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image43.webp";
import image44 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image44.webp";
import image45 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image45.webp";
import image46 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image46.webp";
import image47 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image47.webp";
import image48 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image48.webp";
import image49 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image49.webp";
import image50 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image50.webp";
import image51 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image51.webp";
import image52 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image52.webp";
import image53 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image53.webp";
import image54 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image54.webp";
import image55 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image55.webp";
import image56 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image56.webp";
import image57 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image57.webp";
import image58 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image58.webp";
import image59 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image59.webp";
import image60 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image60.webp";
import image61 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image61.webp";
import image62 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image62.webp";
import image63 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image63.webp";
import image64 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image64.webp";
import image65 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image65.webp";
import image66 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image66.webp";
import image67 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image67.webp";
import image68 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image68.webp";
import image69 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image69.webp";
import image70 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image70.webp";
import image71 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image71.webp";
import image72 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image72.webp";
import image73 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image73.webp";
import image74 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image74.webp";
import image75 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image75.webp";
import image76 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image76.webp";
import image77 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image77.webp";
import image78 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image78.webp";
import image79 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image79.webp";
import image80 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image80.webp";
import image81 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image81.webp";
import image82 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image82.webp";
import image83 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image83.webp";
import image84 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image84.webp";
import image85 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image85.webp";
import image86 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image86.webp";
import image87 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image87.webp";
import image88 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image88.webp";
import image89 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image89.webp";
import image90 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image90.webp";
import image91 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image91.webp";
import image92 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image92.webp";
import image93 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image93.webp";
import image94 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image94.webp";
import image95 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image95.webp";
import image96 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image96.webp";
import image97 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image97.webp";
import image98 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image98.webp";
import image99 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image99.webp";
import image100 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image100.webp";
import image101 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image101.webp";
import image102 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image102.webp";
import image104 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image104.webp";
import image105 from "../../../../../assets/Images/Highlights/LanguageDept/2022-2023/Image105.webp";


export const yearTwentyTwentyTwoThree = [
  image1,
  image2,
  image3,
  image4,
  image5,
  image6,
  image7,
  image8,
  image9,
  image10,
  image11,
  image12,
  image13,
  image14,
  image15,
  image16,
  image17,
  image18,
  image19,
  image20,
  image21,
  image24,
  image25,
  image26,
  image27,
  image28,
  image29,
  image30,
  image31,
  image32,
  image33,
  image34,
  image35,
  image36,
  image37,
  image38,
  image39,
  image40,
  image41,
  image42,
  image43,
  image44,
  image45,
  image46,
  image47,
  image48,
  image49,
  image50,
  image51,
  image52,
  image53,
  image54,
  image55,
  image56,
  image57,
  image58,
  image59,
  image60,
  image61,
  image62,
  image63,
  image64,
  image65,
  image66,
  image67,
  image68,
  image69,
  image70,
  image71,
  image72,
  image73,
  image74,
  image75,
  image76,
  image77,
  image78,
  image79,
  image80,
  image81,
  image82,
  image83,
  image84,
  image85,
  image88,
  image86,
  image87,
  image89,
  image90,
  image91,
  image92,
  image93,
  image94,
  image95,
  image96,
  image97,
  image98,
  image99,
  image100,
  image101,
  image102,
  image104,
  image105,
]
